import styled, { keyframes, css } from "styled-components";
import { IColors, ICornerRadius } from "@swiggy-private/dls-web-common/dist/components/types.internal";

const makeItDisplayAnimation = keyframes`
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
`;

export const StyledButton = styled.div<{
    bgColor?: keyof IColors;
    borderRadius?: keyof ICornerRadius;
}>`
    ${({ bgColor, borderRadius, theme }) => css`
        animation: ${makeItDisplayAnimation} 0.25s ease-in;
        will-change: opacity;
        display: flex;
        align-items: center;
        padding: 11px 16px;
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.24);
        color: #ffffffea;
        border-radius: ${theme.cornerRadius.medium};
        background-color: ${bgColor ? theme.colors[theme.colorMode][bgColor] : "#1b1e24"};
        ${borderRadius && css`
            border-radius: ${theme.cornerRadius[borderRadius]} !important;
        `}
    `}
`;